import { render, staticRenderFns } from "./MobilePreventionSafetyRequestUpdate.vue?vue&type=template&id=32824814&scoped=true&"
import script from "./MobilePreventionSafetyRequestUpdate.vue?vue&type=script&lang=js&"
export * from "./MobilePreventionSafetyRequestUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MobilePreventionSafetyRequestUpdate.vue?vue&type=style&index=0&id=32824814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32824814",
  null
  
)

export default component.exports